import { FC } from 'react';

const DutyItemCrewsEv: FC<{ title: string }> = ({ title }) => {
  return <span className="flex h-[26px] justify-center items-center bg-specialGray-012 text-specialGray-075 px-3 text-xs leading-[18px] rounded-full">{title}</span>;
};

export default DutyItemCrewsEv;
